module.exports = __webpack_public_path__ + "static/media/1015001BE.dcef28a8.jpg";